<template>
  <DatatableReportV3
    v-if="tenantLoaded"
    ref="revenue_datatable"
    title="Revenue"
    :source="source"
    :config="config"
    :filters="filters"
  />
</template>

<script>
import { mapGetters, mapState } from "vuex";

import CONSTANTS from "@/Constants.js";
import DepartmentLink from "@/Department/DepartmentLink.vue";
import JobOpportunityLink from "@/Job/Opportunity/JobOpportunityLink.vue";
import AccountingClassLink from "@/Reports/AccountingClassLink.vue";
import DatatableReportV3 from "@/Reports/DatatableReportV3.vue";
import TagList from "@/Tags/TagList.vue";
import store from "@/vuex/store";
import RevenueActionsContextMenu from "./RevenueActionsContextMenu.vue";

export default {
  components: {
    DatatableReportV3
  },
  props: {
    source: {
      type: String,
      default: ""
    },
    filters: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapGetters(["showAccountingClasses"]),
    ...mapState({
      tenantLoaded({ tenant }) {
        return !!tenant;
      }
    }),
    config() {
      return {
        order: [[0, "desc"]],
        columns: [
          {
            data: "completed_on",
            title: "Completed",
            aggregateTitle: CONSTANTS.AGGREGATE_HEADERS.days,
            filterName: "finalized_at",
            searchable: false
          },
          {
            data: "invoice",
            aggregateTitle: CONSTANTS.AGGREGATE_HEADERS.invoices
          },
          {
            data: "customer",
            aggregateTitle: CONSTANTS.AGGREGATE_HEADERS.customers
          },
          { data: "customer_email", title: "Email" },
          { data: "customer_phone", title: "Phone" },
          {
            data: "billing_address",
            title: "Billing Address",
            orderable: false
          },
          { data: "job" },
          { data: "tags", title: "Tags", orderable: false, searchable: false },
          { data: "location_name", title: "Location Name", orderable: false },
          {
            data: "service_address",
            title: "Service Address",
            orderable: false
          },
          {
            data: "department",
            aggregateTitle: CONSTANTS.AGGREGATE_HEADERS.departments,
            filterName: "department_id",
            searchable: false
          },
          {
            data: "technician",
            title: "Owner",
            filterName: "technician_id",
            searchable: false
          },
          {
            data: "accounting_class",
            title: "Class",
            orderable: false,
            searchable: false,
            visible: this.showAccountingClasses
          },
          {
            data: "invoice_last_emailed_at",
            title: "Last Emailed",
            searchable: false
          },
          { data: "batch_date", title: "Batched", searchable: false },
          {
            data: "revenue",
            className: "text-right",
            footerClassName: "aggregate-currency",
            aggregateTitle: CONSTANTS.AGGREGATE_HEADERS.revenue,
            searchable: false
          },
          {
            data: "balance",
            title: "Balance",
            className: "text-right",
            aggregateTitle: CONSTANTS.AGGREGATE_HEADERS.balance,
            footerClassName: "aggregate-currency",
            footerCellClass: "text-danger",
            filterName: "paid",
            searchable: false
          },
          {
            data: "actions",
            title: "",
            orderable: false,
            className: "text-center th-no-text",
            searchable: false
          }
        ],
        vueComponents: [
          {
            rootId: "department-modal-vue",
            component: DepartmentLink,
            options: {
              store
            }
          },
          {
            rootId: "job-opportunity-modal-vue",
            component: JobOpportunityLink,
            options: {
              store
            }
          },
          {
            rootId: "accounting-class-link-vue",
            component: AccountingClassLink,
            options: {
              store
            }
          },
          {
            rootId: "invoices-context-menu-vue",
            component: RevenueActionsContextMenu,
            options: {
              store
            }
          },
          {
            rootId: "tag-list-vue",
            component: TagList
          }
        ]
      };
    }
  }
};
</script>

<style lang="scss" scoped>
:deep(td .delegated-icon) {
  display: none;
}
</style>
